import { render, staticRenderFns } from "./AllDisputesPage.vue?vue&type=template&id=28bd8c92&scoped=true"
import script from "./AllDisputesPage.vue?vue&type=script&lang=js"
export * from "./AllDisputesPage.vue?vue&type=script&lang=js"
import style0 from "./AllDisputesPage.vue?vue&type=style&index=0&id=28bd8c92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd8c92",
  null
  
)

export default component.exports